<template>
  <div>
    <zj-layout-container
      v-loading="loading"
      :element-loading-text="loadingText"
    >
      <zj-layout-header>
        <div class="listtitle">区域管理</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="区域名称">
            <el-input
              v-model="areaName"
              placeholder="请输入区域名称"
            ></el-input>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
            <el-button @click="toggleExpandAll">展开/折叠</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              v-if="refreshTable"
              :data="tableData"
              row-key="id"
              :default-expand-all="isExpandAll"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <el-table-column
                prop="areaName"
                label="区域名称"
              ></el-table-column>
              <el-table-column
                prop="sourceByTranslated"
                label="区域来源"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="addDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >新增</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import { listEquipmentArea, delEquipmentArea } from "@/api/src/equipmentArea";
export default {
  name: "RegionManagerList",
  controller: "UI",
  action: "RegionManagerList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],

      loading: false,
      loadingText: "",
      areaName: null,
      // 是否展开，默认全部展开
      isExpandAll: true,
      // 重新渲染表格状态
      refreshTable: true,
    };
  },
  created() {
    this.search();
    // this.getParamConfigTree();
  },
  methods: {
    /** 查询区域列表 */
    search() {
      this.loading = true;
      let searchInfo = {
        areaName: this.areaName,
        PageSize: this.pageSize,
        pageNum: this.currentPage,
      };
      listEquipmentArea(searchInfo).then((response) => {
        //this.tableData = response.rows;
        this.tableData = this.handleTree(response.rows, "id", "pid");
        this.total = response.total;
        this.loading = false;
      });
    },
    /** 展开/折叠操作 */
    toggleExpandAll() {
      this.refreshTable = false;
      this.isExpandAll = !this.isExpandAll;
      this.$nextTick(() => {
        this.refreshTable = true;
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/area/UI/RegionManagerView",
        query: {
          type: "add",
          isRow: false,
        },
      });
    },
    //查看
    addDetail(index, row) {
      this.$router.push({
        path: "/plugin/area/UI/RegionManagerView",
        query: { InfoId: row.id, type: "add", isRow: true },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/area/UI/RegionManagerView",
        query: { InfoId: row.id, type: "edit", isRow: false },
      });
    },
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/area/UI/RegionManagerView",
        query: { InfoId: row.id, type: "query", isRow: false },
      });
    },
    //行删除
    deleteClick(index, row) {
      if (row.children && row.children.length > 0) {
        this.$message({
          type: "warning",
          message: "存在下级区域,不允许删除",
        });
        return;
      }
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delEquipmentArea(row.id)
            .then(() => {
              this.search();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.areaName = null;
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
